module.exports = __webpack_public_path__ + "img/screenshot-map.d735b688.svg";